import { ReactComponent as ApplySVG } from "./apply.svg";
import { SvgIcon } from '@mui/material';

export default function IconApply(props) {
  return <SvgIcon {...props} component={ApplySVG} viewBox="0 0 25 24" />;
}